import { ReactNode } from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import MODAL_TYPE from "@utils/enums/modal-type";
import { ModalOption } from "@utils/models/modal";

export interface ModalState {
  modalType: MODAL_TYPE[];
  formValues: Record<string, unknown>[];
  options: ModalOption[];
  visible?: boolean;
}

export interface OpenModalPayloadAction<
  F extends Record<never, unknown> = Record<string, unknown>,
> {
  modalType: MODAL_TYPE;
  options?: ModalOption | object;
  formValues?: F;
}

export interface SetModalTitlePayloadAction {
  modalIndex: number;
  title: string | ReactNode;
}

const initialState = {
  visible: false,
  modalType: [],
  formValues: [],
  options: [],
} as ModalState;

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<OpenModalPayloadAction>) => {
      const { formValues, modalType, options } = action.payload;

      return {
        ...state,
        visible: true,
        modalType: [...state.modalType, modalType],
        options: [...state.options, options ?? {}],
        formValues: [...state.formValues, formValues ?? {}],
      };
    },
    closeModal: (state, action) => {
      const tmpModalType = [...state.modalType];
      const tmpOptions = [...state.options];
      const tmpFormValues = [...state.formValues];

      return {
        ...state,
        visible: state.modalType.length > 1,
        modalType: [...tmpModalType.splice(0, tmpModalType.length - 1)],
        options: [...tmpOptions.splice(0, tmpOptions.length - 1)],
        formValues: [...tmpFormValues.splice(0, tmpFormValues.length - 1)],
      };
    },
    setModalTitle: (state, action: PayloadAction<SetModalTitlePayloadAction>) => {
      const { modalIndex, title } = action.payload;
      const { options } = state;
      options[modalIndex].title = title;

      return {
        ...state,
        options,
      };
    },
    closeAllModal: (state, action) => {
      return initialState;
    },
  },
});

export const modalSelector = (state: any) => state.modal as ModalState;

export const { openModal, closeModal, setModalTitle, closeAllModal } = modalSlice.actions;
export default modalSlice.reducer;
